import React from "react";
import { useTranslation,Trans } from 'react-i18next';

function Copyrights() {

  return (

    <div className="innerwrapper copyrights">
          <p className="text-13">
          <Trans
              i18nKey="copyrights_txt"
              components={{
                a: (
                  <a href="https://www.blossomsfood.com.sg/" target="_blank"/>
                ),
              }}
            />
            </p>
    </div>

    );
}

export default Copyrights;
